import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Consulta() {
  const {
    t
  } = useLanguage();
  const [submitted, setSubmitted] = useState(false);
  const fields = [{
    number: '01',
    label: t.field1_label,
    name: 'name',
    placeholder: t.field1_placeholder,
    type: 'text' as const
  }, {
    number: '02',
    label: t.field2_label,
    name: 'email',
    placeholder: t.field2_placeholder,
    type: 'email' as const
  }, {
    number: '03',
    label: t.field3_label,
    name: 'phone',
    placeholder: t.field3_placeholder,
    type: 'tel' as const
  }, {
    number: '04',
    label: t.field4_label,
    name: 'projectType',
    placeholder: t.field4_placeholder,
    type: 'text' as const
  }, {
    number: '05',
    label: t.field5_label,
    name: 'brief',
    placeholder: t.field5_placeholder,
    type: 'textarea' as const
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="consulta" className="bg-kinetic-bg py-16 md:py-24 px-5 sm:px-6" data-id="element-13" data-mp="2zi0i4demi3f5">
      <div className="container mx-auto" data-id="element-14" data-mp="3kx3vlbbhblbt">
        <span className="text-xs text-cyan-400 uppercase tracking-widest" data-id="element-15" data-mp="3fy9fwi8t6cvx">
          ● {t.consulta_label}
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black text-white mt-4" data-id="element-16" data-mp="3unp2rn57xy6c">
          {t.consulta_heading}
        </h2>
        <p className="text-white/50 mt-4 max-w-xl text-sm sm:text-base" data-id="element-17" data-mp="3ptubnynaagx8">{t.consulta_sub}</p>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12 mt-10 md:mt-16" data-id="element-18" data-mp="7k0tjrwvqic7">
          <div className="md:col-span-3" data-id="element-19" data-mp="3g2t9dvtj1hk">
            {submitted ? <div className="flex items-start sm:items-center gap-3 bg-white/5 border border-cyan-400/30 rounded-xl p-5 sm:p-6" data-id="element-20" data-mp="hf2jur2w5qgd">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0" data-id="element-21" data-mp="chtvu9v2as77" />
                <p className="text-white/80 text-sm sm:text-base" data-id="element-22" data-mp="2j89uvobh1lwg">{t.consulta_success}</p>
              </div> : <form onSubmit={handleSubmit} data-id="element-23" data-mp="2eai4wzue09uw">
                {fields.map(field => <div key={field.name} className="mb-5 sm:mb-6" data-id="element-24" data-mp="i73n3viblken">
                    <label htmlFor={field.name} className="block text-xs text-white/40 uppercase tracking-widest mb-2" data-id="element-25" data-mp="n3kdkwczsauw">
                      {field.number} &nbsp; {field.label}
                    </label>
                    {field.type === 'textarea' ? <textarea id={field.name} name={field.name} placeholder={field.placeholder} rows={4} required className="w-full bg-transparent border-b border-white/20 text-white text-sm sm:text-base py-3 sm:py-4 outline-none focus:border-cyan-400 transition-colors placeholder:text-white/30" data-id="element-26" data-mp="113ln107boqlz" /> : <input id={field.name} name={field.name} type={field.type} placeholder={field.placeholder} required={field.name !== 'phone'} className="w-full bg-transparent border-b border-white/20 text-white text-sm sm:text-base py-3 sm:py-4 outline-none focus:border-cyan-400 transition-colors placeholder:text-white/30" data-id="element-27" data-mp="1ouhc3pke97pj" />}
                  </div>)}

                <button type="submit" className="w-full sm:w-auto bg-yellow-400 text-black font-bold px-6 sm:px-8 py-3.5 sm:py-4 rounded mt-2 sm:mt-4 text-sm sm:text-base hover:bg-yellow-300 transition-colors" data-id="element-28" data-mp="2cpato3k697a8">
                  {t.consulta_submit}
                </button>
              </form>}
          </div>

          <div className="md:col-span-2" data-id="element-29" data-mp="30ggekx4yypre">
            <div className="bg-kinetic-card border border-white/[0.08] rounded-xl p-5 sm:p-8" data-id="element-30" data-mp="2vmu9bq14xo5m">
              <span className="text-xs text-cyan-400 uppercase tracking-widest" data-id="element-31" data-mp="2g5m52vu14frc">
                ● {t.whatsapp_label}
              </span>
              <h3 className="text-xl sm:text-2xl font-bold text-white mt-3" data-id="element-32" data-mp="2l69y1n1tj6o7">
                {t.whatsapp_heading}
              </h3>
              <div className="w-8 h-0.5 bg-white/20 my-4 sm:my-6" data-id="element-33" data-mp="2b6j1lftp6hlh" />
              <p className="text-white/50 text-sm sm:text-base" data-id="element-34" data-mp="2b8vgfk45sbub">{t.whatsapp_body}</p>
              <a href="https://wa.me/34634234462" target="_blank" rel="noopener noreferrer" className="block w-full text-center border border-white/20 text-white text-sm sm:text-base py-3.5 sm:py-4 rounded mt-6 sm:mt-8 hover:bg-white/5 transition-colors" data-id="element-35" data-mp="2ywwv7arxkoi6">
                {t.whatsapp_cta}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}